<template>
    <div class="warriors-slider" :class="{'has-intro': !intersected}" ref="slider" v-if="isActive">
        <div class="warriors-slider__content" ref="content">
          <div v-for="(item, index) in items" :key="index" class="warriors-slider__item" ref="item" @mouseover="onMouseOverItem($event, index)" @mouseleave="onMouseLeaveItem($event, index)">
            <img class="warriors-slider__item__image" :src="item.acf.cover_image.url" :alt="item.acf.cover_image.url">
            <div class="warriors-slider__item__text">
              warrior<span class="warriors-slider__item__number">n°{{ item.acf.number }}</span>
            </div>
            <div class="warriors-slider__overlay__bg"></div>
            <div class="warriors-slider__overlay">
                <p class="warriors-slider__overlay__title" v-html="item.acf.displayed_title" @click="onCLickItemTitle(item.id)"></p>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import * as Hammer from 'hammerjs' 

import MathUtils from '@/utils/MathUtils'
import EventHub from '@/utils/EventHub'

export default {
  name: 'AppWarriorsSlider',

  components: {

  },

  data() {
    return {
      intersected: false,
      intersectionObserver: null,
      items: [],
      isMobile: false,
      isActive: false
    }
  },

  created()
  {
    this.addListeners()

    this.slider = {
      containerWidth: 0,
      itemWidthRatio: 0.54,
      maxItemWidth: null,
      width: 0,
      limits: {
        left: 0,
        right: 0
      },
      canDrag: true,
      drag: {
        dragging: false,
        x: 0,
        start: {
          x: 0
        },
        target: {
          x: 0
        }
      },
      parallaxValue: 0.1,
      items: [],
      domItemsImages: []
    }

    this.isIntersecting = false
  },

  mounted()
  {
    this.windowObj = {
      width: window.innerWidth,
      height: window.innerHeight
    }

    if(this.windowObj.width <= 768)
    {
      this.isMobile = true
    }

    if(this.isMobile)
    {
      this.slider.itemWidthRatio = 0.7
    }

    const endpoint = '/wp-json/acf/v3/warriors'
    this.loadDatas(endpoint)
  },

  destroyed()
  {
    this.removeListeners()
    this.destroySlider()
  },

  methods: {
    addListeners()
    {
      EventHub.$on('window:resize', this.onResize)
      EventHub.$on('application:on-tick', this.onTick)
    },

    removeListeners()
    {
      EventHub.$off('window:resize', this.onResize)
      EventHub.$off('application:on-tick', this.onTick)
      this.intersectionObserver.disconnect()
    },

    loadDatas(endpoint)
    {
      fetch(process.env.VUE_APP_WP_API + endpoint)
        .then((res) => res.json())
        .then((res) =>
        {
          if(res.length > 2)
          {
            this.isActive = true
            this.onLoadedDatas(res)
          }
          else
          {
            this.isActive = false
          }
        })
    },

    onLoadedDatas(res)
    {
      this.items = res

      this.$nextTick(() => {
        const windowObj = {
          width: window.innerWidth,
          height: window.innerHeight
        } 
        this.onResize(windowObj)

        this.initSlider()
        this.addIntersectionObserver()
        this.mooveSliderToIndex(1)
      })
    },

    getFullWidth()
    {
      let fWidth = 0

      for(let i = 0; i < this.$refs.item.length; i++)
      {
        const item = this.$refs.item[i]
        const marginRight = parseInt(window.getComputedStyle(item).marginRight)

        let roundedWidth = Math.ceil(this.slider.containerWidth * this.slider.itemWidthRatio)

        if(this.slider.maxItemWidth)
        {
          roundedWidth = roundedWidth > this.slider.maxItemWidth ? this.slider.maxItemWidth : roundedWidth
        }
    
        this.$refs.item[i].style.width = `${roundedWidth}px`

        if(this.slider.parallaxValue > 0)
        {
          this.slider.items[i] = {}
          this.slider.items[i].limits = {}
          this.slider.items[i].left = fWidth
  
          fWidth += roundedWidth + marginRight
  
          this.slider.items[i].width = roundedWidth
          this.slider.items[i].right = this.slider.items[i].left + roundedWidth

          this.slider.items[i].limits.left = this.slider.items[i].left - this.slider.items[i].width
          this.slider.items[i].limits.right = this.slider.items[i].left + this.windowObj.width + this.slider.items[i].width
        }
        else
        {
          fWidth += roundedWidth + marginRight
        }

      }

      return fWidth
    },

    setSliderWidth(fWidth)
    {
      this.$refs.content.style.width = `${fWidth}px`
    },

    initSlider()
    {
      this.sliderManager = new Hammer.Manager(this.$refs.content)
      this.sliderManager.add(new Hammer.Pan({ threshold: 0, pointers: 0 }))

      this.sliderManager.on('pan', (ev) => 
      {
        this.onPan(ev)
      })

      this.sliderManager.on('panstart', (ev) => 
      {
        this.onPanStart(ev)
      })

      this.domItemsImages = this.$el.querySelectorAll('.warriors-slider__item__image')

      this.$refs.item.forEach((elem, index) => 
      {
        const hammertime = new Hammer(elem, {})

        const elemIndex = index

        hammertime.on('tap', (ev) => 
        {
          this.onClickElem(ev, elemIndex)
        })
      })
    },

    addIntersectionObserver()
    {
      const options = {
        threshold: 0
      }

      this.intersectionObserver = new IntersectionObserver(entries => {
          const par = entries[0]

          if (par.isIntersecting)
          {
              this.intersected = true
              this.isIntersecting = true
          }
          else
          {
            this.isIntersecting = false
          }
      }, options)

      this.intersectionObserver.observe(this.$el)
    },
    
    destroySlider()
    {
      this.sliderManager.off('pan', (ev) => 
      {
        this.onPan(ev)
      })

      this.sliderManager.off('panstart', (ev) => 
      {
        this.onPanStart(ev)
      })
    },

    onClickElem(ev, index)
    {
      if(!ev.target.classList.contains('warriors-slider__overlay__title'))
      {
        this.$refs.content.classList.add('has-transition')
  
        setTimeout(() => {
              this.$refs.content.classList.remove('has-transition')
          }, 400)
  
        if(index === 0)
        {
          this.slider.drag.x = this.slider.limits.right
          this.slider.drag.target.x = this.slider.limits.right
        }
        else if(index + 1 === this.items.length)
        {
          this.slider.drag.x = this.slider.limits.left
          this.slider.drag.target.x = this.slider.limits.left
        }
        else
        {
          this.mooveSliderToIndex(index)
        }
      }
    },

    mooveSliderToIndex(index)
    {
      const itemTranslate = this.slider.width / this.items.length
      let translateValue = (itemTranslate * index + itemTranslate / 2) * -1 + this.windowObj.width / 2
      translateValue = MathUtils.clamp(translateValue, this.slider.limits.left, this.slider.limits.right)

      this.slider.drag.x = translateValue
      this.slider.drag.target.x = translateValue
    },

    onCLickItemTitle(id)
    {
      this.$router.push({ name: 'warrior', params: { id } })
    },

    onPanStart(ev)
    {
      if(this.slider.canDrag)
      {
        this.slider.drag.dragging = true
        this.slider.drag.start.x = ev.deltaX + this.slider.drag.x
      }
    },

    onPan(ev)
    {
      if(this.slider.canDrag)
      {
        let xVal = this.slider.drag.start.x + ev.deltaX * 1.5
        xVal = MathUtils.clamp(xVal, this.slider.limits.left, this.slider.limits.right)
  
        this.slider.drag.target.x = xVal
  
        if(ev.isFinal)
        {
          this.slider.drag.dragging = false
        }
      }
    },

    onMouseOverItem(ev, index)
    {
      if(!this.slider.drag.dragging && this.slider.canDrag && !this.isMobile)
      {
        this.$refs.item[index].classList.add('is-hover')
      }
    },

    onMouseLeaveItem(ev, index)
    {
      this.$refs.item[index].classList.remove('is-hover')
    },

    onTick()
    {
      if(this.isActive && this.isIntersecting)
      {
        this.slider.drag.x = MathUtils.lerp(this.slider.drag.x, this.slider.drag.target.x, 0.1)
        this.$refs.content.style.transform = `translateX(${ this.slider.drag.x }px)`
        
        if(this.slider.parallaxValue > 0)
        {
          const scrollLeft = this.slider.drag.x * -1
          const scrollRight = this.slider.drag.x * -1 + this.windowObj.width

          for(let i = 0; i < this.slider.items.length; i++)
          {
            const item = this.slider.items[i]

            if((item.left >= scrollLeft && item.left <= scrollRight) || (item.right >= scrollLeft && item.right <= scrollRight))
            {
              const progress = MathUtils.linearRange(scrollLeft, this.slider.items[i].left - this.windowObj.width, item.right, -1, 1)

              let transformVal = progress * (item.width * this.slider.parallaxValue)
              transformVal = Math.round(transformVal * 1000) / 1000

              this.domItemsImages[i].style.transform = `scale(1.1) translate3d(${transformVal}px, 0, 0)`
            }
          }
        }
      }
    },

    onResize(windowObj)
    {
      if(this.isActive)
      {
        this.windowObj = windowObj
  
        if(this.windowObj.width <= 768)
        {
          this.isMobile = true
        }
        else
        {
          this.isMobile = false
        }
  
        if(this.items.length > 0)
        {
          this.slider.containerWidth = windowObj.width
          this.slider.width = this.getFullWidth()
          this.slider.limits.left = -this.slider.width + this.windowObj.width
          this.slider.limits.right = 0
          this.setSliderWidth(this.slider.width)
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
    .warriors-slider
      position relative
      width 100%
      height 100%
      overflow hidden
      interpolate('margin-top', 1600px, 2560px, 170px, 240px);

      @media(max-width 1600px)
        interpolate('margin-top', 768px, 1600px, 70px, 170px);

    .warriors-slider__content
      cursor grab
      font-size 0
      will-change transform
      // display flex
      // flex-direction row
      // flex-wrap nowrap

      &.has-transition
        transition transform 0.4s $ease-out-quad

    .warriors-slider__item
      overflow hidden
      position relative
      // width 58%
      // max-width 700px
      margin-right 40px
      display inline-block

      &:before
        content ''
        display block
        padding-top 125%

      &:last-child
        margin-right 0

      &:nth-child(1)
        transform translate3d(0, 0, 0)
        transition transform 1s $ease-out-quart 

        .has-intro &
          transform translate3d(10%, 0, 0)

      &:nth-child(2)
        transform translate3d(0, 0, 0)
        transition transform 1.1s $ease-out-quart 

        .has-intro &
          transform translate3d(20%, 0, 0)

      &:nth-child(3)
        transform translate3d(0, 0, 0)
        transition transform 1.2s $ease-out-quart

        .has-intro &
          transform translate3d(30%, 0, 0)

    .warriors-slider__item__image
      pointer-events none
      position absolute 
      top 0
      left 0
      width 100%
      height 100%
      transform scale(1.1)

    .warriors-slider__item__text
      z-index 2
      position absolute 
      top 50%
      width 100%
      text-align center
      text-transform uppercase
      color $white
      letter-spacing 0.2em
      font-family 'Sabon'
      transform translateY(-50%)
      interpolate('font-size', 1600px, 2560px, 95px, 122px);

      @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 48px, 95px);

      @media(max-width 768px)
        font-size 26px

    .warriors-slider__item__number
      position absolute
      top 14px
      font-family 'Akzidenz', sans-serif
      font-weight 700
      letter-spacing 0.1em
      interpolate('font-size', 1600px, 2560px, 20px, 25px);

      @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 13px, 20px);

      @media(max-width 768px)
        top 0
        font-size 10px

    // Overlay
    .warriors-slider__overlay
        position absolute
        top 65%
        width 100%
        color $grey-light  
        visibility hidden
        transition visibility 0.2s

        .is-hover &
            visibility visible

        @media(max-width 768px)
          visibility visible

    .warriors-slider__overlay__bg
        position absolute
        top 0
        width 100%
        height 100%
        background #1a1a1a
        opacity 0
        visibility hidden
        // transition opacity 0.2s $ease-out-quad, visibility 0.2s

        .is-hover &
            visibility visible
            opacity 0.8
            // transition opacity 0.2s $ease-out-quad

        @media(max-width 768px)
          visibility visible
          opacity 0.5

    .warriors-slider__overlay__title
        cursor pointer
        max-width 70%
        margin 0 auto
        display block
        text-transform uppercase
        text-align center
        line-height 1
        opacity 0
        visibility hidden
        interpolate('font-size', 1600px, 2560px, 60px, 84px);

        @media(max-width 1600px)
          interpolate('font-size', 768px, 1600px, 30px, 60px);
        // transform translate3d(0, 40px, 0) scale(0.9)
        // transition transform 0.2s $ease-out-quad, opacity 0.2s $ease-out-quad

        .is-hover &
            opacity 1
            visibility visible
            // transform translate3d(0, 0, 0) scale(1)

        @media(max-width 768px)
          font-size 18px
          opacity 1
          visibility visible
          // transform translate3d(0, 0, 0) scale(1)

</style>